module.exports = __webpack_public_path__ + "img/header-light.a6559c34.svg";